export const MAPBOX_TOKEN =
  'pk.eyJ1IjoicmFwa2luIiwiYSI6ImNpbDJqMjdtbjAwYnN3N20wcm5ocjZwNzQifQ.1e1M_mLQuD0xyi7ZrP0DCQ'
export const API_URL = 'https://api.lametsy.com.ua/api'
